import { useTranslation } from "react-i18next";
import { setTextLoaderTestId } from "./text-loader.utils";

export function TextLoader() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full items-center justify-center" data-testid={setTextLoaderTestId("container")}>
      <div className="animate-pulse text-muted-foreground">{t("common.loading")}</div>
    </div>
  );
}
